import ManageNotes from "./ManageNotes";
import ManageTags from "./ManageTags";
import { useMemo } from "react";
import { ContactInfo, Listing } from "src/types/listing";
import { PropertyDetails, PropertyDetailsProps } from "./PropertyDetails";

export type ListingDetailsProps = {
  listing: Listing;
  isLoading: boolean;
  isError: boolean;
  listingId: string;
  children: React.ReactNode;
  setIsManageNotesOpen: (open: boolean) => void;
  setIsManageTagsOpen: (open: boolean) => void;
  isManageNotesOpen: boolean;
  isManageTagsOpen: boolean;
  onSaveTagsClick: (tags: string[]) => void;
  onAddNoteClick: (note: string) => void;
  onDeleteNoteClick: (noteId: string) => void;
  PropertyDetailsProps?: Partial<PropertyDetailsProps>;
  onToggleContactIsDisabled?: (contact: ContactInfo, isDisabled: boolean) => void;
};
const ListingDetails = ({
  listing,
  isLoading,
  isError,
  listingId,
  children,
  setIsManageNotesOpen,
  setIsManageTagsOpen,
  isManageNotesOpen,
  isManageTagsOpen,
  onSaveTagsClick,
  onAddNoteClick,
  onDeleteNoteClick,
  PropertyDetailsProps,
  onToggleContactIsDisabled,
}: ListingDetailsProps) => {
  const isReady = useMemo(
    () => !isLoading && !isError && listing,
    [isLoading, isError, listing]
  );

  return (
    <section className="details-page-root justify-center">
      <div
        className={`content-pane flex-col gap-12 bg-white overflow-hidden`}
      >
        <div className="w-full">
          {isReady && (
            <>
              {isManageNotesOpen && (
                <ManageNotes
                  key={`manage-notes-${listingId}`}
                  onDeleteClick={onDeleteNoteClick}
                  onAddClick={onAddNoteClick}
                  onClose={() => setIsManageNotesOpen(false)}
                  open
                  notes={listing?.notes || []}
                />
              )}
              {isManageTagsOpen && (
                <ManageTags
                  key={`manage-tags-${listingId}`}
                  onClose={() => setIsManageTagsOpen(false)}
                  onSaveClick={onSaveTagsClick}
                  open
                  tags={listing?.tags || []}
                />
              )}
            </>
          )}
          <PropertyDetails
            listing={listing}
            isLoading={isLoading}
            isNotesEnabled
            isTagsEnabled
            onAddNoteClick={() => setIsManageNotesOpen(true)}
            onAddTagClick={() => setIsManageTagsOpen(true)}
            onToggleContactIsDisabled={onToggleContactIsDisabled}
            {...PropertyDetailsProps}
          />
          <div className="w-full mt-5 pt-5">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ListingDetails;
